import OrderCargoOrderActiveListResponse, {
  OrderCargoOrderActiveListResponseItem,
  OrderCargoOrderActiveListResponseItemStatus,
} from "../../../../api/raily/order/cargo-order/active-list/order-cargo-order-active-list.response";
import OrderCargoOrderActiveList, {
  OrderCargoOrderActiveListItem,
  OrderCargoOrderActiveListItemExecutionStatus,
} from "./order-cargo-order-active-list";

const createExecutionStatus = (
  responseStatus: OrderCargoOrderActiveListResponseItemStatus,
): OrderCargoOrderActiveListItemExecutionStatus => {
  switch (responseStatus) {
    case OrderCargoOrderActiveListResponseItemStatus.CANDIDATURE:
      return OrderCargoOrderActiveListItemExecutionStatus.CANDIDATURE;
    case OrderCargoOrderActiveListResponseItemStatus.IN_PROGRESS:
      return OrderCargoOrderActiveListItemExecutionStatus.IN_PROGRESS;
    case OrderCargoOrderActiveListResponseItemStatus.PENDING:
      return OrderCargoOrderActiveListItemExecutionStatus.PENDING;
    case OrderCargoOrderActiveListResponseItemStatus.PLANNED:
      return OrderCargoOrderActiveListItemExecutionStatus.PLANNED;
  }
};

const createDataItem = (
  responseItem: OrderCargoOrderActiveListResponseItem,
): OrderCargoOrderActiveListItem => {
  return {
    uuid: responseItem.id,
    client: responseItem.client.id
      ? {
          name: responseItem.client.name,
        }
      : null,
    consumer: responseItem.consumer?.id
      ? {
          name: responseItem.consumer.name,
        }
      : null,
    dispatch: responseItem.dispatch,
    drivers: responseItem.drivers,
    externalOrderId: responseItem.externalId,
    internalOrderId: responseItem.humanId,
    isMobileAppUser: responseItem.push,
    passengers: responseItem.passengers,
    producer: responseItem.producer.id
      ? {
          id: responseItem.producer.id,
          name: responseItem.producer.name,
        }
      : null,
    routeAddresses: responseItem.rideAddresses,
    estimatedStartDate: responseItem.startTime,
    executionStatus: createExecutionStatus(responseItem.status),
    taxiCorporations: responseItem.taxiCorporations,
    attentions: {
      newSharedPost: responseItem.attentions?.newSharedPost,
      newPlanEntryPost: responseItem.attentions?.newPlanEntryPost,
      cargoOrderEdit: responseItem.attentions?.cargoOrderEdit,
      cargoOrderCancel: responseItem.attentions?.cargoOrderCancel,
    },
    slkStatus: responseItem.slkStatus ?? null,
  };
};

const createData = (
  responseData: OrderCargoOrderActiveListResponseItem[],
): OrderCargoOrderActiveListItem[] => {
  return responseData.map(createDataItem);
};

const create = (
  response: OrderCargoOrderActiveListResponse,
): OrderCargoOrderActiveList => {
  return {
    data: createData(response.data),
  };
};

const cargoOrderActiveListFactory = {
  create,
};

export default cargoOrderActiveListFactory;
